import styled from 'styled-components';
import { isMobile } from 'utils/is-mobile';

export const MarketsWrapper = styled.div<{ isTheatreMode?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: row;
  ${props => !props.isTheatreMode && !isMobile() && 'overflow: auto;'}
  ${isMobile()
    ? `
      margin: 4px 4px 0
    `
    : `
      margin-top: 2px;
    `}
`;

export const MarketColumn = styled.div<{
  fullWidth: boolean;
  columnIndex: number;
}>`
  overflow: auto;
  flex: 1;
  width: ${props => (props.fullWidth ? '100%' : '50%')};
  ${props => (props.columnIndex == 1 ? 'margin-left: 4px' : '')}
  ${isMobile() &&
  `
    border-radius: 4px;
  `}
`;

export const CombinCount = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: var(--v3-black-45);
`;
